$(function(){
  
  function Expander( navItem ) {
   this.element = navItem;
   this.trigger = this.element.find('.expandable-nav-item-trigger');
   this.submenu = this.element.find('.sub-menu-expandable');
   this.contentHeight = this.submenu.outerHeight();
   this.expanded = true;
   this.setup();
  }
  
  Expander.prototype.setup = function() {
	this.contract();
    this.events();
  };
  
  Expander.prototype.events = function() {
  	this.trigger.bind('click', this.toggle.bind(this));
  };

  Expander.prototype.toggle = function( e ) {
    
    e.preventDefault();
    
    if ( this.expanded ) {
      
      $(e.currentTarget).removeClass('active');
      
      this.contract();
      
    } else {
      
      $(e.currentTarget).addClass('active');
      
      this.expand();
      
    }
    
  }
  
  Expander.prototype.expand = function() {
    this.submenu.css('height',this.contentHeight).addClass('active');
    this.expanded = true;
  };
  
  Expander.prototype.contract = function() {
    this.submenu.css('height',0).removeClass('active');
    this.expanded = false;
  };
  
  
  function setup() {
   var expandables = $('.expandable-nav-item');
    
    for ( var i = 0, len = expandables.length; i < len; i++ ) {
    	new Expander( $(expandables[ i ]) );
    }
    
  }
  
  setup();

});